import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sb-threeway-toggle-button',
  templateUrl: './sb-threeway-toggle-button.component.html',
  styleUrls: ['./sb-threeway-toggle-button.component.scss'],
  standalone: false,
})
export class SbThreewayToggleButtonComponent implements OnInit {
  modelValue: number;

  @Output()
  modelChange = new EventEmitter<number>();

  @Input() disabled = false;

  @Input()
  set model(prm: number) {
    this.modelValue = prm;
    this.modelChange.emit(this.modelValue);
  }

  get model(): number {
    return this.modelValue;
  }

  constructor() {}

  ngOnInit() {}

  click(value: number) {
    if (this.model === value) {
      if (value !== -1) {
        this.model = -1;
      } else {
      }
    } else {
      this.model = value;
    }
  }
}
